export default __webpack_public_path__ + "static/php-2eb2596e3451bef054b19693d9de81ae.svg";